import dateFormat from 'dateformat';

// TYPE Guards
import {isDate} from '../../types/type-guards';

import {appConfig} from '@stencil/hotels-config';

const {defaultCheckinOffset, defaultCheckoutOffset} = appConfig;

export function addDays(theDate: Date, days = 1) {
  const newDate = new Date();
  newDate.setHours(0, 0, 0);
  const changeDate = theDate || newDate;
  let transformedDate = new Date(changeDate.getTime() + days * 24 * 60 * 60 * 1000);
  transformedDate.setHours(0, 0, 0, 0);
  return transformedDate;
}

export function compareDates(firstDate: Date, secondDate: Date, comparisonFn = (a, b) => a > b) {
  const d1 = new Date(firstDate);
  d1.setHours(0, 0, 0, 0);
  const d2 = new Date(secondDate);
  d2.setHours(0, 0, 0, 0);
  return comparisonFn(d1, d2);
}

export function compareDate(firstDate: Date, secondDate: Date, comparisonFn = (a, b) => a < b) {
  return comparisonFn(firstDate, secondDate);
}

export function gaCheckinDateDifference(checkin: Date) {
  let dateDelta = defaultCheckinOffset;
  if (checkin !== null) {
    const diff = new Date(checkin).getTime() - new Date().getTime();
    dateDelta = Math.round(diff / 86400000);
  }

  return dateDelta;
}

export function parseUrlDateString(str: string) {
  const data = new Date(str.replace(/(\d\d\d\d)(\d\d)(\d\d)/g, '$1-$2-$3'));
  return data;
}

export function modifyMonthForDate(date: Date, value: number) {
  const temp = new Date(date);
  temp.setMonth(temp.getMonth() + value);
  return new Date(temp);
}

export function parseDateIntoHermesString(date: Date) {
  return dateFormat(date, 'yyyymmdd');
}

export function convertDayIndexingToSatSunFormat(date: Date) {
  if (date.getDay() === 0) return 6;
  return date.getDay() - 1;
}

export function getMonthDifferenceBetweenTwoDates(d1: Date, d2: Date) {
  var months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth() + 1;
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
}

export function timeCalculation(date) {
  const submitDate = new Date(date);
  const today = new Date();
  const timeDiff = Math.abs(submitDate.getTime() - today.getTime());
  if (timeDiff < 60) {
    return 'few seconds ago';
  }
  const diffMinutes = Math.ceil(timeDiff / (1000 * 60));
  if (diffMinutes < 60) {
    return diffMinutes === 1 ? diffMinutes + ' minute ago' : diffMinutes + ' minutes ago';
  }
  const diffHours = Math.ceil(timeDiff / (1000 * 60 * 60));
  if (diffHours < 24) {
    return diffHours === 1 ? diffHours + ' hour ago' : diffHours + ' hours ago';
  }
  const diffDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
  if (diffDays < 30) {
    return diffDays === 1 ? diffDays + ' day ago' : diffDays + ' days ago';
  }
  const diffMonths = Math.ceil(timeDiff / (1000 * 60 * 60 * 24 * 30));
  if (diffMonths < 12) {
    return diffMonths === 1 ? diffMonths + ' month ago' : diffMonths + ' months ago';
  }
  const diffYears = Math.ceil(timeDiff / (1000 * 60 * 60 * 24 * 30 * 12));
  if (diffYears > 0) {
    return diffYears === 1 ? diffYears + ' year ago' : diffYears + ' years ago';
  }
}

export function twoDatesAreSame(date1: Date, date2: Date) {
  if (!(isDate(date1) && isDate(date2))) {
    return;
  }

  const date1WithoutTime = date1.setHours(0, 0, 0, 0);
  const date2WithoutTime = date2.setHours(0, 0, 0, 0);

  return date1WithoutTime === date2WithoutTime;
}
